import * as moment from "moment-timezone";
import * as _ from "lodash";
import { Table } from "react-bootstrap";
import { IMoveTracker, IBaseResponse } from "@nkr/models/index";
import { DisplayType, ActiveLogisticsPlan } from "@nkr/enums/index";
import { TableBodyWrapper, TableHeadWrapper } from './styles';
import MoveTrackerListRow from "./move-tracker-list-row";

interface IProps {
    list: IMoveTracker[],
    displayType: DisplayType,
    displayTimeZone: string,
    backgroundColor?: string,
    textColor?: string,
    borderColor?: string,
    headerBackgroundColor?: string,
    headerBackgroundTextColor?: string,
    enableNotes?: boolean,
    isCourier: boolean,
    noRowsMessage?: string | JSX.Element,
    onSwitchPlan: (item: IMoveTracker) => void,
    onViewLogistics: (item: IMoveTracker) => void,
    onSaveNotes: (donorId: number, notes: string) => Promise<IBaseResponse>,
    onAcknowledgeAlert: (chainId: number, clusterNumber: number, positionNumber: number) => void
}

const MoveTrackerList = (props: IProps) => {
    const handleShowMap = (url: string) => {
        window.open(url);
    };

    const handleShowGps = (url: string) => {
        window.open(url);
    };

    const handleSwitchPlan = (item: IMoveTracker) => {
        props.onSwitchPlan(item);
    };

    const handleViewLogistics = (item: IMoveTracker) => {
        props.onViewLogistics(item);
    };

    const handleSaveNotes = (donorId: number, notes: string) => {
        return props.onSaveNotes(donorId, notes);
    };

    const handleAcknowledgeAlert = (chainId: number, clusterNumber: number, positionNumber: number) => {
        props.onAcknowledgeAlert(chainId, clusterNumber, positionNumber);
    };

    const localTimeZone = moment.tz.zone(moment.tz.guess()).abbr(moment().milliseconds());

    return (
        <Table condensed striped>
            <TableHeadWrapper fontSize={14} borderColor={props.borderColor} backgroundColor={props.headerBackgroundColor} textColor={props.headerBackgroundTextColor}>
                <tr>
                    <th>R#</th>
                    <th>Officer</th>
                    <th style={{ width: "5%" }}>Swap #</th>
                    <th style={{ width: "10%" }}>Donor<br />Center</th>
                    <th>Scheduled<br />Pickup</th>
                    <th>Recipient<br />Center</th>
                    <th>Scheduled<br />Delivery</th>
                    {props.isCourier == false && (
                        <th>Courier</th>
                    )}
                    <th>Logistics</th>
                    <th>Transport<br />Method</th>
                    <th style={{ width: "8%" }}>Pickup</th>
                    <th style={{ width: "8%" }}>Flight<br />Leg 1</th>
                    <th style={{ width: "8%" }}>Flight<br />Leg 2</th>
                    <th style={{ width: "8%" }}>Recovery<br />From Airline</th>
                    <th style={{ width: "8%" }}>Delivery</th>
                </tr>
            </TableHeadWrapper>
            <TableBodyWrapper fontSize={14} borderColor={props.list.length > 0 ? props.borderColor : null}>
                {props.list.map((item, index) => {
                    return (
                        <MoveTrackerListRow
                            key={'move-tracker-row-' + index}
                            item={item}
                            index={index}
                            useBackupPlan={item.activeLogisticsPlan == ActiveLogisticsPlan.Backup.toString()}
                            displayTimeZone={props.displayTimeZone}
                            localTimeZone={localTimeZone}
                            backgroundColor={props.backgroundColor}
                            textColor={props.textColor}
                            borderColor={props.borderColor}
                            enableNotes={props.enableNotes}
                            isCourier={props.isCourier}
                            onViewLogistics={handleViewLogistics}
                            onShowMap={handleShowMap}
                            onShowGps={handleShowGps}
                            onSwitchPlan={handleSwitchPlan}
                            onSaveNote={handleSaveNotes}
                            onAcknowledgeAlert={handleAcknowledgeAlert}
                        />
                    );
                })}

                {props.list.length == 0 && props.noRowsMessage && (
                    <tr><td colSpan={15}>{props.noRowsMessage}</td></tr>
                )}
            </TableBodyWrapper>
        </Table>
    );
}

export default MoveTrackerList;